export const dashboardSelector = (state) => state.dashboardModule;
